import { ProviderAdminObjectThreatReasonModel } from '../../../provider-admin-object-threat-reason-model';

export class ZimbraMailingReportProfileFilterRule {
  name: string;
  reasonObjects: ProviderAdminObjectThreatReasonModel[];
  reasons: string;
  redirectOrForwardEmails: string[];
}
